import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AbstractLocalStorageService } from 'src/app/moov-common/services/localStorage/local-storage.abstract.service';
import { LocalStorageKeys } from 'src/app/moov-common/services/localStorage/local-storage.enum';
import { PersonalUserData } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';

@Component({
  selector: 'app-verify-phone-number',
  templateUrl: './verify-phone-number.component.html',
  styleUrl: './verify-phone-number.component.scss'
})
export class VerifyPhoneNumberComponent extends BaseComponent implements OnInit {
  isAllowedToResend : boolean = false;
  timeLeft : number = 30;
  translationParams : {};
  interval : any;
  isVerificationProcessCompleted : boolean = false;
  verificationProcessSucceeded : boolean = false;
  imageRootFolder = "assets/userProfile/";
  isLoading : boolean = false;
  constructor(private dialogRef: MatDialogRef<VerifyPhoneNumberComponent>,
              private readonly userService : AbstractPersonalUserDataService,
              private readonly localStorageService : AbstractLocalStorageService){
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    // call stage 1 in verification - start timer for resend (30Sec)
    this.translationParams = {seconds : this.timeLeft};

      this.verifyPhoneNumberStage1();
      this.startTimer();
    }

  startTimer() {
    this.timeLeft = 30;
    this.isAllowedToResend = false;
    this.interval = setInterval(() => {
        if(this.timeLeft > 1) {
          this.timeLeft--;
          this.translationParams = {seconds : this.timeLeft};
        } else {
          this.translationParams = {seconds : ""};
          this.isAllowedToResend = true;
        }
    },1000)
  }

  onInput(event: Event, currentInput: HTMLInputElement, previousInput: HTMLInputElement | null, nextInput: HTMLInputElement | null): void {
    const value = currentInput.value;
  
    // Move to next input if a single digit is entered
    if (value.length === 1 && nextInput) {
      nextInput.focus();
      nextInput.select();
    }
  }
 

onKeyUp(event: KeyboardEvent, currentInput: HTMLInputElement, previousInput: HTMLInputElement | null, nextInput: HTMLInputElement | null): void {
  // Check if the backspace key was pressed
  if (event.key === 'Backspace' && previousInput && !currentInput.value) {
    previousInput.focus();
    previousInput.select();
  }
}

  // Function to handle paste event
  onPaste(event: ClipboardEvent): void {
    if (!event.clipboardData) {
      return;
    }
  
    let pastedData = event.clipboardData.getData('text');
    pastedData = pastedData.replace(/\D/g, ''); // Ensure only digits are considered
  
    if (pastedData.length === 6) {
      const targetElement = event.target as HTMLInputElement;
      if (targetElement && targetElement.parentElement) {
        const inputs = targetElement.parentElement.querySelectorAll('input');
        inputs.forEach((input: HTMLInputElement, index: number) => {
          if (input) {
            input.value = pastedData[index] || '';
          }
        });
  
        // Focus the last input if you want
        const lastInput = inputs[inputs.length - 1] as HTMLInputElement;
        if (lastInput) {
          lastInput.focus();
        }
      }
    }
  }

  close(): void{
    this.dialogRef.close(this.verificationProcessSucceeded);

  }

  retryVerification(): void{
    this.isVerificationProcessCompleted = false;
    this.verifyPhoneNumberStage1();
    this.startTimer();
  }

  retryVerificationAfterFailure(): void{
    this.isVerificationProcessCompleted = false;
  }

  verifyPhoneNumberStage1(): void{
    this.userService.verifyPhoneNumber_stage1().subscribe(res => {});
  }

  codeSubmitted(userCode: string): void{
    this.isLoading = true;

    this.userService.verifyPhoneNumber_stage2(userCode).subscribe(isVerified => {
      console.log(`VPN codeSubmitted isVerified ${isVerified}`);
      this.verificationProcessSucceeded = isVerified;  
      this.isVerificationProcessCompleted = true;
      this.isLoading = false;

      if (isVerified){
        this.userService.getUserDetails(this.user!.id).subscribe(userDetails => {
          this.localStorageService.write<PersonalUserData>(LocalStorageKeys.userPersonalInfo, userDetails);
        })
      }
    })
  }
}
